"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _nuiIntl = require("@concur/nui-intl");

var _reactRouter = require("react-router");

var _utils = require("../utils");

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/SearchBar.css") : void 0;

var _trackClick = _interopRequireDefault(require("../HOCs/trackClick"));

var _withAppContext = require("../HOCs/withAppContext");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var extractValue = function extractValue(cb, e) {
  cb(e.target.value);
};

var SearchBar =
/*#__PURE__*/
function (_Component) {
  _inherits(SearchBar, _Component);

  function SearchBar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SearchBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SearchBar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleSearch", function (e) {
      e.preventDefault();

      if (!_this.props.search) {
        return;
      }

      document.title = _this.props.context.getTitle("Search: ".concat(_this.props.search));

      _this.props.router.push("".concat((0, _utils.getAppCenterPathName)(_this.props.location.pathname), "/search/").concat(encodeURIComponent(_this.props.search)));

      _this.props.filterApps();
    });

    return _this;
  }

  _createClass(SearchBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          search = _this$props.search,
          onChange = _this$props.onChange,
          router = _this$props.router,
          location = _this$props.location,
          host = _this$props.host,
          formatter = _this$props.formatter;
      var TrackedButton = (0, _trackClick.default)(_react.default.createElement("button", {
        id: "ac-search-btn",
        className: "btn btn-lg btn-default search-btn-spacing"
      }, _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "Search"
      })), 'CLICK', {
        context: router.location.pathname === "".concat((0, _utils.getAppCenterPathName)(location.pathname)) ? 'HOME' : 'LISTING_DETAILS',
        type: 'BUTTON',
        value: 'SEARCH',
        searchKeyword: search,
        domain: {
          host: host
        }
      });
      return _react.default.createElement("div", {
        className: "search-bar-container"
      }, _react.default.createElement("form", {
        onSubmit: this.handleSearch
      }, _react.default.createElement("input", {
        className: "ac-search-bar form-control input-lg",
        placeholder: formatter.formattedMessage({
          id: 'FindApps'
        }),
        value: search,
        type: "text",
        onChange: extractValue.bind(undefined, onChange)
      }), _react.default.createElement(TrackedButton, null)));
    }
  }]);

  return SearchBar;
}(_react.Component);

SearchBar.propTypes = {
  search: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  filterApps: _propTypes.default.func.isRequired,
  router: _propTypes.default.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  location: _propTypes.default.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  host: _propTypes.default.string,
  formatter: _propTypes.default.object // eslint-disable-line react/forbid-prop-types

};

function mapStateToProps(state) {
  return {
    host: state.meta.host
  };
}

var _default = (0, _reactRouter.withRouter)((0, _withAppContext.withAppContext)((0, _nuiIntl.withFormatter)((0, _reactRedux.connect)(mapStateToProps, {})(SearchBar))));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/shared/SearchBar.js
// module id = 242
// module chunks = 0